import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchElementPropertyByElement } from "../ElementPropertyByElement";
import { toggleLoading } from "../../LoadingSlice";
import { toast } from "react-toastify";

interface StockDetailsState {
  StockDetails: {
    load: boolean;
    data: [];
  };
}

export const StockDetailsSlice = createSlice({
  name: "StockDetails",
  initialState: {
    StockDetails: {
      load: false,
      data: [],
    },
  } as StockDetailsState,
  reducers: {
    resetStockDetailsState: (state: any) => {
        state.StockDetails.data = [];
    },
},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchStockDetails.pending, (state: StockDetailsState) => {
        state.StockDetails.load = true;
      })
      .addCase(fetchStockDetails.fulfilled, (state: StockDetailsState, action: any) => {
        state.StockDetails.data = action.payload;
        state.StockDetails.load = false;
      })
      .addCase(fetchStockDetails.rejected, (state: StockDetailsState) => {
        state.StockDetails.load = false;
      })
  },
});

export const { resetStockDetailsState } = StockDetailsSlice.actions;
export default StockDetailsSlice.reducer;

export const fetchStockDetails = createAsyncThunk(
  "StockDetails/fetchStockDetails",
  async (param: { apiParam : {warehouse_id: any, element_property_pin: any, element_pin: any, summary_element_pin: any} }, thunkAPI) => {
    try { 
      thunkAPI.dispatch(toggleLoading());     
      const { data } = await DataServer.post("api/getElementPropertyDetails", {
        summary_element_pin: param.apiParam.summary_element_pin,
        warehouse_id: param.apiParam.warehouse_id,
        element_property_pin: param.apiParam.element_property_pin,
        element_pin: param.apiParam.element_pin,
      });
      thunkAPI.dispatch(toggleLoading());
      return data.data;

    } catch (error) {
      thunkAPI.dispatch(toggleLoading());
      return(error);
    }
  }
);

export const postNewStock = createAsyncThunk(
  "StockDetails/postNewStock",
  async (param: { apiParam: { element_property_pin: any, warehouse_id: any; required_qty: any; add_new_stock: any, login_user_id: any, element_pin: any, tpi_firm_id: any, summary_element_pin:any, manufacturer: any, specification: any } }, thunkAPI) => {
    try {
      const { data } = await DataServer.post("api/postNewStock", {
        element_property_pin: param.apiParam.element_property_pin,
        login_user_id: param.apiParam.login_user_id,
        required_qty: param.apiParam.required_qty,
        add_new_stock: param.apiParam.add_new_stock,
        summary_element_pin: param.apiParam.summary_element_pin,
        warehouse_id: param.apiParam.warehouse_id,
        manufacturer: param.apiParam.manufacturer,
        specification: param.apiParam.specification
      });

      toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});

      const handleonConfirm = () => {
        thunkAPI.dispatch(fetchElementPropertyByElement({ apiParam: { warehouse_id: param.apiParam.warehouse_id, tpi_firm_id: param.apiParam.tpi_firm_id, summary_element_pin: param.apiParam.summary_element_pin, route_identify:'PRSES_TPI_STOCK', project_pin: "" } }));
      };

      return data.data;
    } catch (error) {
      toast.error("Something went wrong!",{theme: "colored"});
      return error;
    }
  }
);
